import api from '@/api/teachbot';

const getTeachBotResponse = (context, msg) => new Promise(((resolve, reject) => {
  api.sendMessageToBot(msg)
    .then((response) => {
      context.commit('GET_BOT_RESPONSE', response.data);
      resolve(response.data);
    })
    .catch((error) => {
      // eslint-disable-next-line
        console.error(error);
      reject(error);
    });
}));

const getTranslatedText = (context, text) => new Promise(((resolve, reject) => {
  api.translateText(text)
    .then((response) => {
      context.commit('GET_TRANSLATED_TEXT', response.data.translations[0].translatedText);
      resolve(response);
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error);
      reject(error);
    });
}));

export default {
  getTeachBotResponse,
  getTranslatedText
};



// WEBPACK FOOTER //
// ./src/store/modules/teachbot/actions.js